import React from 'react';

import ActivationStepContent from './ActivationGate/ActivationStepContent';
import ActivationWizardModal from './ActivationGate/ActivationWizardModal';
import { useCollaboratorActivationWizard } from '../hooks/useCollaboratorActivationWizard';
import {
  CommissioningCollaborator,
  CreateCommissioningCollaboratorFormState
} from '../types';

type Props = {
  open: boolean;
  collaborator: CommissioningCollaborator | null;
  isBrokerAdmin: boolean;
  isEstateAdmin: boolean;
  estateOptions: Array<{ key: string; text: string; value: string }>;
  saving: boolean;
  onClose: () => void;
  onSubmit: (form: CreateCommissioningCollaboratorFormState) => void;
};

const EditCollaboratorModal: React.FC<Props> = ({
  open,
  collaborator,
  isBrokerAdmin,
  isEstateAdmin,
  estateOptions,
  saving,
  onClose,
  onSubmit
}) => {
  const isActiveCollaborator = collaborator?.status === 'ACTIVE';

  const wizard = useCollaboratorActivationWizard({
    open: open && !isActiveCollaborator,
    mode: 'edit',
    isBrokerAdmin,
    isEstateAdmin,
    defaultEstateId: collaborator?.estateId || '',
    estateOptions,
    collaborator
  });

  const handleFinish = () => {
    if (isActiveCollaborator) {
      onClose();
      return;
    }
    if (!wizard.validateAllSteps()) return;

    onSubmit({
      ...wizard.form,
      estateId: wizard.selectedEstateId
    });
  };

  if (isActiveCollaborator) {
    return null;
  }

  return (
    <ActivationWizardModal
      open={open}
      title="Editar colaborador"
      finishButtonText="Salvar alterações"
      onClose={onClose}
      activationStep={wizard.activationStep}
      lastActivationStep={wizard.lastActivationStep}
      activationSaving={saving}
      activationStepError={wizard.activationStepError}
      recipientType={wizard.form.recipientType}
      onBack={() => wizard.handleBackStep(onClose)}
      onNext={wizard.handleNextStep}
      onFinish={handleFinish}
    >
      <ActivationStepContent
        mode="collaborator"
        activationStep={wizard.activationStep}
        activationForm={wizard.form}
        updateActivationFormField={wizard.updateFormField}
        handleZipCodeLookup={wizard.handleZipCodeLookup}
        addressLookupLoading={wizard.addressLookupLoading}
        addressLookupError={wizard.addressLookupError}
        addressAutoFilled={wizard.addressAutoFilled}
        isBrokerAdmin={isBrokerAdmin}
        estateOptions={estateOptions}
        userOptions={wizard.userOptions}
        usersLoading={wizard.usersLoading}
        selectedEstateId={wizard.selectedEstateId}
        onEstateChange={wizard.setEstateId}
        onUserChange={wizard.applySelectedUser}
      />
    </ActivationWizardModal>
  );
};

export default EditCollaboratorModal;
